import { render } from "./DomainOl.vue?vue&type=template&id=f6bb9e04"
import script from "./DomainOl.vue?vue&type=script&lang=js"
export * from "./DomainOl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__